var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditioner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / \xD0\x9A\xD0\xBE\xD0\xBD\xD0\xB4\xD0\xB8\xD1\x86\xD0\xB8\xD0\xBE\xD0\xBD\xD0\xB5\xD1\x80 large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M43.7498 6.24984L31.2498 6.24984M43.7498 14.5832L31.2498 14.5832M43.7498 22.9165L31.2498 22.9165M11.4582 28.6619V9.37483C11.4582 6.49835 13.79 4.1665 16.6665 4.1665C19.543 4.1665 21.8748 6.49835 21.8748 9.37484V28.6619C24.3873 30.3437 26.0415 33.2077 26.0415 36.4582C26.0415 41.6358 21.8442 45.8332 16.6665 45.8332C11.4888 45.8332 7.2915 41.6358 7.2915 36.4582C7.2915 33.2077 8.9457 30.3437 11.4582 28.6619ZM18.7498 36.4582C18.7498 37.6088 17.8171 38.5415 16.6665 38.5415C15.5159 38.5415 14.5832 37.6088 14.5832 36.4582C14.5832 35.3076 15.5159 34.3748 16.6665 34.3748C17.8171 34.3748 18.7498 35.3076 18.7498 36.4582Z",
    stroke: "#956446",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditioner);
export default __webpack_public_path__ + "static/media/conditioner.9e5f020d7f556000e72687a32164a53c.svg";
export { ForwardRef as ReactComponent };